import type { Disclosure } from "@engine/round/aggregate";

export function isOfficiallyRecused(
  disclosure: Disclosure | undefined,
): boolean {
  // User is considered recused if:
  // 1. They have a disclosure where hasDisclosure is true
  // AND
  // 2. The official decision for them on this proposal is "recused".

  return (
    disclosure !== undefined &&
    disclosure.hasDisclosure &&
    disclosure.decision === "recused"
  );
}

export function interestBg(
  interest: number | undefined,
  isEditable: boolean = false,
): string {
  if (interest == null) {
    return isEditable ? "" : "light:bg-gray-100 dark:bg-stone-800";
  }
  if (interest === 0) {
    return "light:bg-yellow-100 dark:bg-yellow-500";
  }
  if (interest === 1) {
    return "light:bg-lime-100 dark:bg-lime-500";
  }
  if (interest === 2) {
    return "light:bg-lime-200 dark:bg-lime-600";
  }
  if (interest === 3) {
    return "light:bg-lime-300 dark:bg-lime-700";
  }
  return "light:bg-green-300 dark:bg-green-700";
}

export function formatInvestigationInterestDisplay(
  interest: number | null | undefined,
  isRecused: boolean,
): string {
  if (isRecused) return "Rec";
  return interest == null ? "" : String(interest);
}

export function getInterestDescription(
  value: number | null | undefined,
  isRecused: boolean,
) {
  if (isRecused) return "Recused";
  if (value == null) {
    return "";
  }
  switch (value) {
    case 0:
      return "Definitely don't want to";
    case 1:
      return "Probably don't";
    case 2:
      return "Maybe (~50%)";
    case 3:
      return "Probably";
    case 4:
      return "Definitely";
    default:
      return "";
  }
}

export function getReviewProgressDescription(
  value: number | null | undefined,
  isRecused: boolean,
) {
  if (isRecused) return "Recused";
  if (value == null) {
    return "";
  }
  switch (value) {
    case 1:
      return "Skimmed";
    case 2:
      return "Mostly read";
    case 3:
      return "Wrote notes";
    case 4:
      return "Investigated (e.g. had a call and wrote notes)";
    default:
      return "";
  }
}

export function totalColumnColor(total: number, numMembers: number) {
  if (total < numMembers) {
    return "light:bg-yellow-100 dark:bg-yellow-500";
  }
  if (total < numMembers * 2) {
    return "light:bg-lime-100 dark:bg-lime-500";
  }
  if (total < numMembers * 3) {
    return "light:bg-lime-300 dark:bg-lime-700";
  }
  return "light:bg-green-300 dark:bg-green-700";
}

export function skimmedColumnColor(total: number, numMembers: number) {
  if (total < numMembers / 3) {
    return "light:bg-yellow-100 dark:bg-yellow-500";
  }
  if (total < (numMembers * 2) / 3) {
    return "light:bg-lime-200 dark:bg-lime-600";
  }
  return "light:bg-green-300 dark:bg-green-700";
}
